export default __webpack_public_path__ + "static/media/aries.84ef789e.png";